// extracted by mini-css-extract-plugin
export default {"Navigation_mobile_container":"DrawerMenu_Navigation_mobile_container__GGppz"};